import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';

import isEmpty from "../../../../utils/helpers";
import FormSelect from "../../../../components/UI/FormSelect";
import TextInput from "../../../../components/UI/TextInput";

import { hideModal } from '../../../../actions/modal.actions';
import {
    createLoadingSelector,
    getModalData,
    getAdmin,
    getUser
} from '../../../../selectors';

import {
    getSystemLocations,
    addPartner,
    updatePartner,
} from '../../../../actions/admin.actions';

import { getUserSummary } from "../../../../actions/user.actions";
import Loader from "src/components/Loader";

import Select from "react-select";
import { groupStyles } from "src/utils/SelectStyles";

import { getAccounts, emptyAccounts } from "../../../../actions/account-search";

class AddPartnerModal extends Component {
    state = {
        alertMessage: '',
        isLoadingLocations: true,
     //   isLoadingBillingModes: true,
        selectedAccountsOptions: [],
    };

    componentDidMount() {
        const p1 = this.props.getSystemLocations();

        Promise.resolve(p1).finally(() => this.setState({ isLoadingLocations: false }));
    }

    componentWillUnmount() {
        if (this.timeout) clearTimeout(this.timeout);
        this.props.emptyAccounts();
    }

    partnerSchema = () => {
        return Yup.object().shape({
            name: Yup.string().required('Required'),
            description: Yup.string().required('Required'),
            locations: Yup.array().min(1, 'Minimum one location is required'),
           // billingMode: Yup.object().required('Required'),
            accountNumber: Yup.number()
                .nullable()
                .typeError('Invalid value')
                .min(1, 'Invalid value')
        });
    };

    formSubmit = (values, actions) => {
        const { currentUser, getUserSummary } = this.props;

        this.setState({ alertMessage: '' }, () => {
            const method = this.props.modalProps.type === 'create'
                ? this.props.addPartner
                : this.props.updatePartner;

            const postData = { ...values };

            // locations → locationIds
            postData.locationIds = postData.locations.map(location => location.id);
            delete postData.locations;

            // billingMode → billingModeId
            // if (postData.billingMode) {
            //     postData.billingModeId = postData.billingMode.id;
            // }
           // delete postData.billingMode;

            // helper-only fields
            delete postData.selectedAccountsInput;
            delete postData.selectedAccountOption;

            method(postData).then((response) => {
                if (!response.data) {
                    actions.setSubmitting(false);
                    this.setState({ alertMessage: 'Unknown error. Please try again later' });
                    return;
                }

                if (!response.data.success) {
                    actions.setSubmitting(false);
                    if (response.data.error.code === "C00226") {
                        this.setState({
                            alertMessage: "More than one account found in the system. Provide a different Account #"
                        });
                        return;
                    }

                    this.setState({ alertMessage: response.data.error.message });
                    return;
                }

                this.props.hideModal();
                this.props.modalProps.reloadPartners();

                if (currentUser.partner && currentUser.partner.id === values.id) {
                    getUserSummary();
                }
            });
        });
    };

    loadAccountInfo = (values, setFieldValue) => (value, option) => {
        if (option?.action !== 'input-change') return;

        setFieldValue('selectedAccountsInput', value);

        if (this.timeout) clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
            this.props.getAccounts('ACCOUNT NUMBER', value).then(response => {
                const updatedSelectedAccountsOptions = (response || []).map(acct => ({
                    label:
                        acct.number +
                        ' - ' +
                        (acct.systemUser
                            ? `${acct.systemUser.firstName} ${acct.systemUser.lastName}`
                            : acct.name),
                    value: acct.number, // store accountNumber here
                    _id: acct.id,       // optional
                }));

                this.setState({ selectedAccountsOptions: updatedSelectedAccountsOptions });
            });
        }, 500);
    };

    setAccountNumber = (values, setFieldValue) => (option, actionMeta) => {
        if (actionMeta.action === 'clear') {
            setFieldValue('selectedAccountOption', null);
            setFieldValue('accountNumber', null);
            return;
        }

        if (actionMeta.action === 'select-option') {
            setFieldValue('selectedAccountsInput', '');
            setFieldValue('selectedAccountOption', option);
            setFieldValue('accountNumber', option?.value ?? null);
        }
    };

    scrollDropdownIntoView = (e) => {
        const elementClicked = e.target.nodeName;
        const boundingElement = e.currentTarget;
        const modalBody = document.getElementsByClassName('modal-body')[0];

        if (elementClicked !== 'LABEL') {
            setTimeout(function () {
                if (boundingElement.getBoundingClientRect().bottom > modalBody.getBoundingClientRect().bottom) {
                    if (boundingElement.getBoundingClientRect().height < modalBody.getBoundingClientRect().height) {
                        boundingElement.scrollIntoView({ block: "end" });
                    }
                }
            }, 200);
        }
    }

    render() {
        const { alertMessage, isLoadingLocations, isLoadingBillingModes } = this.state;
        const { modalProps, systemLocations, partnerBillingModes, accountLoading } = this.props;

        const isLoading = isLoadingLocations;

        // const wholesaleMode = !isEmpty(partnerBillingModes)
        //     ? partnerBillingModes.find(mode => mode.name === 'WHOLESALE')
        //     : null;

        const locationOptions = !isEmpty(systemLocations)
            ? systemLocations.map(location => ({ label: location.description, value: location }))
            : [];

        // const partnerBillingModeOptions = !isEmpty(partnerBillingModes)
        //     ? partnerBillingModes
        //         .slice()
        //         .sort((a, b) => a.id - b.id)
        //         .map(billingMode => ({
        //             label: billingMode.description,
        //             value: billingMode
        //         }))
        //     : [];
        //
        // const selectedBillingMode =
        //     modalProps.row?.billingModeId && !isEmpty(partnerBillingModes)
        //         ? partnerBillingModes.find(mode => mode.id === modalProps.row.billingModeId)
        //         : wholesaleMode;


        const defaultSelectedAccountOption =
            modalProps.row?.accountNumber
                ? {
                    label: modalProps.row.accountName
                        ? `${modalProps.row.accountNumber} - ${modalProps.row.accountName}`
                        : `${modalProps.row.accountNumber}`,
                    value: modalProps.row.accountNumber
                }
                : null;


        return (
            <Fragment>
                <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    {isLoading ? (
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        {modalProps.type === 'create' ? 'Add Partner' : 'Edit Partner'}
                                    </h5>
                                    <button onClick={this.props.hideModal} type="button" className="close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <div className="modal-body">
                                    <Loader />
                                </div>

                                <div className="modal-footer">
                                    <button onClick={this.props.hideModal} className="btn" type="button">
                                        Cancel
                                    </button>
                                    <button disabled type="button" className="btn btn-primary">
                                        Loading…
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <Formik
                            enableReinitialize
                            initialValues={{
                                id: (modalProps.row && modalProps.row.id) || null,
                                name: (modalProps.row && modalProps.row.name) || '',
                                description: (modalProps.row && modalProps.row.description) || '',
                                active: modalProps.row ? modalProps.row.active : true,
                                partnerProperties: (modalProps.row && modalProps.row.partnerProperties) || [],
                                locations: (modalProps.row && modalProps.row.locations) || [],
                                accountNumber: (modalProps.row && modalProps.row.accountNumber) || null,
                             //   billingMode: selectedBillingMode,

                                // select helpers
                                selectedAccountsInput: '',
                                selectedAccountOption: defaultSelectedAccountOption,
                            }}
                            validateOnChange={false}
                            validateOnBlur={false}
                            validationSchema={this.partnerSchema()}
                            onSubmit={this.formSubmit}
                            render={({
                                         handleChange,
                                         handleSubmit,
                                         handleBlur,
                                         values,
                                         errors,
                                         touched,
                                         isSubmitting,
                                         setFieldValue
                                     }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="modal-dialog">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    {modalProps.type === 'create' ? 'Add Partner' : 'Edit Partner'}
                                                </h5>
                                                <button onClick={this.props.hideModal} type="button" className="close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>

                                            <div className="modal-body form-horizontal">
                                                {!isEmpty(alertMessage) && (
                                                    <div className="alert alert-inline alert-danger alert-dismissible">
                                                        <p className="mb-0">{alertMessage}</p>
                                                    </div>
                                                )}

                                                <div className="form-group">
                          <span className="h-check">
                            <label>Active&nbsp;</label>
                            <div className="form-check checkbox-slider checkbox-slider--b-flat">
                              <label>
                                <input
                                    name="active"
                                    type="checkbox"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    checked={values.active}
                                />
                                <span>&nbsp;</span>
                              </label>
                            </div>
                          </span>
                                                </div>

                                                <div className="form-group">
                                                    <TextInput
                                                        label="Name"
                                                        name="name"
                                                        value={values.name}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        errors={errors}
                                                        touched={touched}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <TextInput
                                                        label="Description"
                                                        name="description"
                                                        value={values.description}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        errors={errors}
                                                        touched={touched}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <div onClick={this.scrollDropdownIntoView}>
                                                        <FormSelect
                                                            title="Locations"
                                                            fieldName="locations"
                                                            options={locationOptions}
                                                            setFieldValue={setFieldValue}
                                                            value={values.locations}
                                                            isMulti={true}
                                                            onBlur={handleBlur}
                                                            errors={errors}
                                                            touched={touched}
                                                        />
                                                    </div>
                                                </div>

                                                {/*<div className="form-group">*/}
                                                {/*    <div onClick={this.scrollDropdownIntoView}>*/}
                                                {/*        <FormSelect*/}
                                                {/*            title="Billing Mode"*/}
                                                {/*            fieldName="billingMode"*/}
                                                {/*            options={partnerBillingModeOptions}*/}
                                                {/*            setFieldValue={setFieldValue}*/}
                                                {/*            value={values.billingMode}*/}
                                                {/*            onBlur={handleBlur}*/}
                                                {/*            errors={errors}*/}
                                                {/*            touched={touched}*/}
                                                {/*        />*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}

                                                {/* Single-select account search with nice labels */}
                                                <div className="form-group">
                                                    <label>
                                                        {values.billingMode?.name === 'WHOLESALE'
                                                            ? 'Account #'
                                                            : 'Account # (optional)'}
                                                    </label>

                                                    <Select
                                                        id="selectedAccountsInput"
                                                        name="selectedAccountsInput"
                                                        placeholder="Type account number..."
                                                        options={this.state.selectedAccountsOptions}
                                                        inputValue={values.selectedAccountsInput}
                                                        value={values.selectedAccountOption}
                                                        onInputChange={this.loadAccountInfo(values, setFieldValue)}
                                                        onChange={this.setAccountNumber(values, setFieldValue)}
                                                        isMulti={false}
                                                        isClearable={true}
                                                        isLoading={accountLoading}
                                                        isDisabled={isSubmitting}
                                                        styles={groupStyles}
                                                    />

                                                    {touched.accountNumber && errors.accountNumber && (
                                                        <div className="invalid-feedback d-block">
                                                            {errors.accountNumber}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="modal-footer">
                                                <button onClick={this.props.hideModal} className="btn" type="button">
                                                    Cancel
                                                </button>
                                                <button disabled={isSubmitting} type="submit" className="btn btn-primary">
                                                    {modalProps.type === 'create' ? 'Add Partner' : 'Edit Partner'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        />
                    )}
                </div>

                <div className="modal-backdrop show" tabIndex="1" />
            </Fragment>
        );
    }
}

const accountLoader = createLoadingSelector(['ACCOUNT_SEARCH']);

const mapStateToProps = (state) => {
    const systemLocations = getAdmin(state).systemLocations,
    //    partnerBillingModes = getAdmin(state).partnerBillingModes,
        modalProps = getModalData(state).modalProps,
        currentUser = getUser(state).user;

    const accountLoading = accountLoader(state);

    return {
        systemLocations,
        modalProps,
        currentUser,
     //   partnerBillingModes,
        accountLoading
    };
};

const mapDispatchToProps = {
    getSystemLocations,
    hideModal,
    addPartner,
    updatePartner,
    getUserSummary,
    getAccounts,
    emptyAccounts,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPartnerModal);
